module.exports = __webpack_public_path__ + "static/wakame-0aae7370d1515dce2f50938d72058c74.jpg";